import { Row, Card } from 'react-bootstrap'
import { convertDateWithTime } from '../../../../helpers/constants'
import { StyledDetailField } from './GeneralInfo'
import { cardStyle } from './constants'

const DetailMetadata = ({ detail }) => {
  return (
    <>
      {!detail?.is_cross_dock &&
        !detail?.is_external &&
        !detail?.is_consignment && (
          <Row className="mb-3">
            <StyledDetailField
              label="PNP"
              value={detail?.pnp_checker ?? '-'}
              col={4}
            />
            <StyledDetailField
              label="RNR"
              value={detail?.rnr_checker ?? '-'}
              col={4}
            />
          </Row>
        )}
      <Card style={cardStyle}>
        <Row>
          <StyledDetailField
            label="CREATED BY"
            value={!detail?.created_by ? '-' : detail?.created_by}
          />
          <StyledDetailField
            label="CREATED AT"
            value={
              !detail?.created_at || detail?.created_at === '-'
                ? '-'
                : convertDateWithTime(detail?.created_at)
            }
          />
          <StyledDetailField
            label="LAST UPDATED BY"
            value={!detail?.updated_by ? '-' : detail?.updated_by}
          />
          <StyledDetailField
            label="LAST UPDATED AT"
            value={
              !detail?.updated_at || detail?.updated_at === '-'
                ? '-'
                : convertDateWithTime(detail?.updated_at)
            }
          />
        </Row>
      </Card>
    </>
  )
}

export default DetailMetadata
